<template>
<div class="modal fade" id="paymentDetail" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle"><strong>{{ paymentId }}</strong></h5>
                <button role="button" class="border-0 p-0 bg-transparent" @click="closePaymentDetailModal">
                    <svg width="33" height="20" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.265 12.7989C12.5882 9.12215 9.10843 5.63707 5.62069 2.15997C5.09087 1.63016 4.60092 0.826188 3.97271 0.687628C3.07565 0.487784 1.8885 0.487506 1.15129 0.937172C0.0707674 1.59171 -0.0194419 2.83208 0.832571 3.87569C1.54081 4.7436 2.37412 5.51304 3.16752 6.30644C6.37571 9.52527 9.59189 12.7361 12.9625 16.1067C11.5494 17.5198 10.2827 18.7865 9.01334 20.0559C6.45066 22.6185 3.87733 25.1653 1.33594 27.7492C0.0745642 29.0319 0.00566136 30.3042 1.04933 31.3639C2.09299 32.4235 3.39725 32.3972 4.67194 31.1438C8.05427 27.8147 11.3967 24.4404 14.7524 21.0847C15.226 20.611 15.7024 20.1346 16.3437 19.4933C17.4859 20.6355 18.4896 21.6392 19.4933 22.6429C22.2756 25.4251 25.0471 28.2233 27.848 30.9869C29.2643 32.382 30.4914 32.4807 31.5719 31.3684C32.6443 30.264 32.5136 29.0848 31.0892 27.6444C27.8331 24.3617 24.5557 21.1003 21.2862 17.8308C20.807 17.3516 20.3304 16.875 19.7208 16.2654C20.2663 15.6613 20.6894 15.153 21.1577 14.6846C24.4655 11.3662 27.7893 8.06368 31.0891 4.73724C32.4889 3.32683 32.6377 2.08116 31.61 0.97894C30.5157 -0.195159 29.1795 -0.0890008 27.7239 1.356C23.961 5.08692 20.2168 8.84712 16.265 12.7989Z" fill="black" />
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                        <b-spinner></b-spinner> Loading...
                    </div>
                    <table class="table table-striped" v-else-if="paymentDetails && paymentDetails.length > 0">
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(paymentDetail) in paymentDetails" :key="paymentDetail.name">
                                <td>{{ getItemName(paymentDetail.itemid) }}</td>
                                <td>{{ paymentDetail.amount }}</td>
                            </tr>
                        </tbody>

                    </table>
                    <h5 v-else-if="paymentDetails && paymentDetails.length == 0 && !loading" class="text-center text-muted p-4 pt-0 m-0">
                        No Payment Detail
                    </h5>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="closePaymentDetailModal()">Close</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import * as invoiceHelper from '../../store/invoiceHelper';

export default {
    name: 'PaymentDetailModal',
    props: {
        paymentId: String,
        showPaymentDetailModal: Boolean,
        items: Array
    },
    data() {
        return {
            paymentDetails: [],
            loading: false
        };
    },
    computed: {
        ...mapState(["erp_api_url"])
    },
    methods: {
        closePaymentDetailModal() {
            $('#paymentDetail').modal('hide');
            this.$emit("updatepaymentDetailModal");
        },
        async getPaymentDetail() {
            try {
                this.loading = true;
                const paymentDetail = await invoiceHelper.getPaymentDetail(this.paymentId);
                this.paymentDetails = paymentDetail.data;
            } catch (error) {
                console.error("Error Fetching Payment Detail");
            } finally {
                this.loading = false;
            }
        },
        getItemName(itemname) {
            const item = this.items.find(item => item.name === itemname);
            return item ? item.item_name : 'Item not found';
        }
    },
    watch: {
        showPaymentDetailModal: function () {
            if (this.showPaymentDetailModal) {
                this.paymentDetails = [];
                this.getPaymentDetail();
            }
        }
    },
}
</script>

<style scoped>
</style>
